import React from "react";
import Icon from "@mdi/react";
import { IconProps } from "@mdi/react/dist/IconProps";
import { ButtonBase, Typography } from "@mui/material";

export interface IconButtonBadgeProps extends IconProps {
  label: string;
  value: React.ReactNode;
  onClick: () => void;
}

function IconButtonWithLabel(props: IconButtonBadgeProps) {
  const { label, value, onClick, path } = props;

  return (
    <ButtonBase
      sx={{
        borderRadius: 1,
        display: "flex",
        flexDirection: "column",
        p: 1,
        "&:focus, &:hover": {
          bgcolor: "action.hover",
        },
      }}
      onClick={onClick}
    >
      <Icon path={path} size={1} />
      <Typography variant='caption' pt='0.25rem'>
        {label}
      </Typography>
      <Typography
        sx={{
          bgcolor: "primary.main",
          borderRadius: "1rem",
          color: "#ffffff",
          display: "flex",
          fontWeight: "bold",
          justifyContent: "center",
          lineHeight: "1rem",
          mt: "0.5rem",
          minWidth: "2rem",
          opacity: value ? 1 : 0,
          p: "0 0.375rem",
        }}
        color='primary'
        variant='caption'
      >
        {value}
      </Typography>
    </ButtonBase>
  );
}

export default IconButtonWithLabel;
